import { defineComponent as r, computed as o, openBlock as s, createElementBlock as c, createElementVNode as e, toDisplayString as n, createCommentVNode as d, normalizeStyle as f } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "434c2295-f924-4dfb-bdf5-eacec2256432" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), v = { mask: "url(#434c2295-f924-4dfb-bdf5-eacec2256432)" }, u = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "M0 0h222.6l31 23.4L289.4 0H512v222.6l-21.5 31 21.5 35.8V512H289.4l-34.2-20.5-32.6 20.5H0V289.4l22.7-32.6L0 222.6z"
}, null, -1), p = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M222.6 0v222.6H0v66.8h222.6V512h66.8V289.4H512v-66.8H289.4V0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M343.4 162.4a6.2 6.2 0 0 1 6.2-6.1h13.2a38 38 0 0 0 0-75.9h-12.6c-4-3-9.6-5-15.6-5-12.7 0-23 8.3-23 18.4 0 10 10.1 18.2 22.6 18.3h28.6a6.2 6.2 0 0 1 0 12.4h-13.2a38 38 0 0 0 0 75.8h51.1v-31.7h-51.1a6.2 6.2 0 0 1-6.2-6.2zm-200.4 0a6.2 6.2 0 0 1 6.2-6.1h13.2a38 38 0 0 0 0-75.9H150c-4.1-3-9.6-5-15.7-5-12.6 0-22.9 8.3-22.9 18.4 0 10 10 18.2 22.6 18.3h28.5a6.2 6.2 0 0 1 0 12.4h-13.2a38 38 0 0 0 0 75.8h51.1v-31.7h-51a6.2 6.2 0 0 1-6.3-6.2zm200.4 236.2a6.2 6.2 0 0 1 6.2-6.2h13.2a38 38 0 0 0 0-75.8h-12.6c-4-3-9.6-5-15.6-5-12.7 0-23 8.3-23 18.4 0 10 10.1 18.1 22.6 18.3h28.6a6.2 6.2 0 0 1 6.2 6.2 6.2 6.2 0 0 1-6.2 6.2h-13.2a38 38 0 0 0 0 75.8h51v-31.7h-51a6.2 6.2 0 0 1-6.2-6.2zm-200.4 0a6.2 6.2 0 0 1 6.2-6.2h13.2a38 38 0 0 0 0-75.8H150c-4.1-3-9.6-5-15.7-5-12.6 0-22.9 8.3-22.9 18.4 0 10 10 18.1 22.6 18.3h28.5a6.2 6.2 0 0 1 6.2 6.2 6.2 6.2 0 0 1-6.2 6.2h-13.2a38 38 0 0 0 0 75.8h51.1v-31.7h-51a6.2 6.2 0 0 1-6.3-6.2z"
}, null, -1), x = { fill: "none" }, z = ["r"], y = /* @__PURE__ */ r({
  __name: "mq",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(h) {
    const t = h, l = o(() => 512 + 2 * t.strokeWidth), a = o(() => -t.strokeWidth), i = o(() => 256 + t.strokeWidth / 2);
    return (H, w) => (s(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", v, [
        t.flagName ? (s(), c("title", u, n(t.flagName), 1)) : d("", !0),
        k,
        p,
        g
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: i.value,
          fill: "none",
          style: f({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, z)
      ])
    ], 8, _));
  }
});
export {
  y as default
};
//# sourceMappingURL=mq-c451610e.js.map
